import Vue from 'vue';
import Vuex from 'vuex';
import createMutationsSharer from "vuex-shared-mutations"

import authenticationModule from './modules/authentication'
import overviewStepsModule from './modules/overviewSteps'
import adTrackingModule from './modules/adTracking'
import versioningModule from './modules/versioning'
import advisorCodeModule from './modules/advisorCode'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth: authenticationModule,
    overviewSteps: overviewStepsModule,
    versioning: versioningModule,
    adTracking: adTrackingModule,
    advisorCode: advisorCodeModule,
  },
  plugins: [createMutationsSharer({ predicate: ["authSuccess", "logout", "loginAs", "setNumberOfCompletedSteps", "setVersion", "setNewVersionAvailable", "coBrandingUrl", "setOmtId", "setAdReferrer", "setFullReferrer", "setHasSeenPopupSinceLogin"] })]
})
